/* eslint-disable camelcase */
export const mapWorkshopServiceOptions = (services: { id: string; display_name: string }[]) =>
  services?.map(({ id, display_name }) => ({ title: display_name, value: id })) || [];

export const mapWorkshopLocationOptions = (
  location: { id: string; display_name: string; name: string; address: string }[],
) => location?.map(({ id, display_name, name, address }) => ({ title: display_name, value: id, name, address })) || [];
